<div
    *ngIf="svgContent"
    class="svg-icon d-flex justify-content-center"
    [ngStyle]="{'width.px': width, 'height.px': height, 'fill': color}"
    [innerHtml]="svgContent | bypassHtmlSanitizer"
></div>
